import React from "react";
import { Sparkles, Users, Lightbulb, CloudFog, Wine, Camera, Car, Droplets } from "lucide-react";

export default function WhyChooseUs() {
  const reasons = [
    {
      title: "Capacitate până la 300 de persoane",
      description: "Sală spațioasă și elegantă, adaptabilă pentru evenimente intime sau petreceri fastuoase de până la 300 de invitați.",
      icon: <Users strokeWidth={1.5} size={24} />
    },
    {
      title: "Schelă profesională de lumini",
      description: "Sistem complet de iluminat arhitectural pe schelă, cu lumini de scenă controlabile pentru o atmosferă spectaculoasă.",
      icon: <Lightbulb strokeWidth={1.5} size={24} />
    },
    {
      title: "Baloane de spumă",
      description: "Efect spectaculos cu baloane de spumă pentru momente pline de energie și distracție pe ringul de dans.",
      icon: <Droplets strokeWidth={1.5} size={24} />
    },
    {
      title: "Fum greu pentru dansul mirilor",
      description: "Efectul de fum greu transformă primul dans al mirilor într-un moment de poveste, plin de magie și romantism.",
      icon: <CloudFog strokeWidth={1.5} size={24} />
    },
    {
      title: "Bar propriu",
      description: "Bar complet utilat cu băuturi fine și cocktailuri, pentru ca invitații tăi să se bucure de o experiență premium.",
      icon: <Wine strokeWidth={1.5} size={24} />
    },
    {
      title: "Oglindă magică pentru poze instant",
      description: "Oglinda magică oferă fotografii instant interactive, amintiri distractive pe care invitații le pot lua acasă.",
      icon: <Camera strokeWidth={1.5} size={24} />
    },
    {
      title: "Parcare proprie",
      description: "Parcare spațioasă și privată pentru liniștea și confortul tuturor oaspeților tăi.",
      icon: <Car strokeWidth={1.5} size={24} />
    },
    {
      title: "Atmosferă premium",
      description: "Un cadru distins și exclusivist, creat special pentru ca fiecare invitat să se simtă cu totul special.",
      icon: <Sparkles strokeWidth={1.5} size={24} />
    }
  ];

  return (
    <section 
      id="de-ce-noi"
      data-testid="why-choose-us-section"
      className="py-24 sm:py-32 bg-[#121212] relative overflow-hidden"
    >
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#D4AF37]/5 rounded-full filter blur-3xl -z-10" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Title */}
        <div className="text-center space-y-4 mb-20">
          <span className="text-xs font-semibold tracking-[0.3em] text-[#D4AF37] uppercase">
            CALITATE FĂRĂ COMPROMISURI
          </span>
          <h2 
            data-testid="why-choose-us-title"
            className="font-serif-lux text-3xl sm:text-5xl text-white font-medium tracking-tight"
          >
            De Ce Să Alegi Elysium Events?
          </h2>
          <div className="w-24 h-[1px] bg-[#D4AF37]/50 mx-auto mt-4" />
        </div>

        {/* Reasons Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, i) => (
            <div
              key={i}
              data-testid={`reason-card-${reason.title.toLowerCase().replace(/\s+/g, "-")}`}
              className="p-8 bg-black/40 backdrop-blur-xl border border-white/5 hover:border-[#D4AF37]/30 transition-all duration-300"
            >
              <div className="text-[#D4AF37] mb-4 bg-white/5 p-3 rounded-none inline-block border border-white/10">
                {reason.icon}
              </div>

              <h3 className="text-lg font-semibold text-white tracking-wide mb-2 uppercase">
                {reason.title}
              </h3>

              <p className="text-sm text-white/60 leading-relaxed font-light">
                {reason.description}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
